<template>
    <div>
        <div class="flex center-xs space-top-1 space-bottom-2">
            <div class="start-xs vertical-center input-container dropdown-box" >
                <label for="state">{{ step.label }}</label>
                <select @keyup.enter="keycheck" v-model="inputData" class="form-dropdown">
                    <option v-if="step.placeholder" disabled selected>{{ step.placeholder }}</option>
                    <option v-for="value in step.valueList" :key="value" :value="value">{{ value }}</option>
                </select>
            </div>
        </div>

        <ButtonSection
          :inputValid="inputValid"
          :order="order"
          :buttonText="step.buttonText"
          v-on:progress="$emit('progress')"
          v-on:back="$emit('back')"
        />
    </div>
</template>

<script>
import ButtonSection from '../components/ButtonSection';

export default {
    props: ['step', 'order'],
    components: {
        ButtonSection
    },
    computed: {
        inputValid() {
            return this.inputData !== '';
        },
        inputData: {
            get () {
                return this.$store.state.formFields[this.step.name];
            },
            set (value) {
                const name = this.step.name;
                this.$store.commit('updateField', { name, value })
            }
        }
    },
    methods: {
        keycheck(e) {
            if (e.keyCode === 13 && this.inputValid) {
                this.$emit('progress');
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.form-dropdown {
    display: block;
    position: relative;
    max-width: 588px;
    width: 100%;
    padding: 15px .8em 16px;
    border: 3px solid #0384FB;
    box-sizing: border-box;
    color: #302f32;
}

.dropdown-box {
    &::after {
        content: '';
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 7px 5px 0 5px;
        border-color: #302f32 transparent transparent transparent;
        position: absolute;
        right: 25px;
        top: 55px;
        pointer-events: none;
        font-size: .6em;
    }
}
</style>